import jqXHR = JQuery.jqXHR;
import { ApiRoute } from "PFCore/utilities/routes";
import { PermissionsGroup } from "PFTypes";

type CreatePermissionPayload = Partial<PermissionsGroup>;

type CreatePermissionResponse = {
  message: string;
};

export const createPermissionsGroup = (formData: CreatePermissionPayload): jqXHR<CreatePermissionResponse> =>
  // @ts-ignore
  $.ajax({
    type: "POST",
    url: ApiRoute(`/api/admin/permissions_groups`),
    api_version: 2,
    processData: false,
    contentType: "application/json",
    data: JSON.stringify(formData)
  });
